'use strict';

var implementation = require('./implementation');

module.exports = function getPolyfill() {
	if (!String.prototype.trimRight) {
		return implementation;
	}
	var zeroWidthSpace = '\u200b';
	if (zeroWidthSpace.trimRight() !== zeroWidthSpace) {
		return implementation;
	}
	return String.prototype.trimRight;
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/string.prototype.trimright/polyfill.js
// module id = 285
// module chunks = 0